<template>
  <div class="page-wrapper chiller-theme">
      <main class="page-content">
        <router-view />
      </main>
    <loader-item :isLoader='this.$root.fullscreenLoading'></loader-item>
  </div>
</template>
<script>
// import { SidebarMenu } from 'vue-sidebar-menu'
import LoaderItem from '@/components/loader/loader-item.vue'
// import services from '@/helpers/services.js'

// accessTokenaccessToken

export default {
  components: {
    LoaderItem
  },
  data () {
    return {
      containerCollapsed: 'toggled',
      tabledata: []
      // user: JSON.parse(localStorage.getItem('user'))

    }
  },
  created () {
    // services.getNotificationList().then((response) => {
    //   this.$root.rootNotificationCount = response.data.length
    // })
  },
  methods: {
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    },
    goNotificationsPage () {
      this.$router.push('/notifications')
    }
  }
}

</script>
<style scoped>

  .el-aside {
    color: #333;
  }

  .item {
    margin-top: 12px;
    margin-right: 20px;
  }

</style>
